import { useEffect, useMemo, useState } from 'react';

export function useListTableState({
    initialSortBy = 'name',
    initialSortDir = 'asc',
    initialGroupBy = 'none',
    initialPage = 1,
    initialPageSize = 6,
    debounceMs = 850,
    enableGroupScope = false,
    initialGroupScope = 'page',
} = {}) {
    const [qInput, setQInput] = useState('');
    const [qDebounced, setQDebounced] = useState('');
    const [sortBy, setSortBy] = useState(initialSortBy);
    const [sortDir, setSortDir] = useState(initialSortDir);
    const [groupBy, setGroupBy] = useState(initialGroupBy);
    const [groupScope, setGroupScope] = useState(initialGroupScope);

    const [page, setPage] = useState(initialPage);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setQDebounced(qInput.trim());
        }, debounceMs);

        return () => window.clearTimeout(timeoutId);
    }, [debounceMs, qInput]);

    useEffect(() => {
        setPage(1);
    }, [qDebounced, pageSize]);

    const safePage = useMemo(() => Math.min(page, totalPages), [page, totalPages]);

    return {
        qInput,
        setQInput,
        qDebounced,
        sortBy,
        setSortBy,
        sortDir,
        setSortDir,
        groupBy,
        setGroupBy,
        groupScope: enableGroupScope ? groupScope : 'page',
        setGroupScope: enableGroupScope ? setGroupScope : undefined,
        page,
        setPage,
        pageSize,
        setPageSize,
        total,
        setTotal,
        totalPages,
        setTotalPages,
        safePage,
    };
}

export default useListTableState;
